module.exports = __webpack_public_path__ + "img/tft_01.401aa68f.jpg";